export enum ServicesAssociationsLogAction {
  Create = "Create",
  Delete = "Delete",
  Deactivate = "Deactivate",
  Reactivate = "Reactivate",
}

export const ServicesAssociationsLogActionLabels: Record<string, string> = {
  [ServicesAssociationsLogAction.Create]: "Criação",
  [ServicesAssociationsLogAction.Delete]: "Exclusão",
  [ServicesAssociationsLogAction.Deactivate]: "Inativação",
  [ServicesAssociationsLogAction.Reactivate]: "Reativação",
};

export default ServicesAssociationsLogAction;
